<template>

    <div class="make-sub-model">
        <div class="make-model-navigation__select make-sub-model__button">
            <!-- <select v-bind:class="{ 'selected': selections.year != '', 'errored': selections.year == '' && showError }"
                name="year" id="" v-model="selections.year" :disabled="dropdowns.year.length < 1">
                <option value="">{{ yearLabel || 'Select Year' }}</option>
                <option v-for="year in dropdowns.year" :key="year.key" :value="year.key" :has-foam="year.hasFoam" title="Not available for foam">{{ year.value }}</option>
            </select> 
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 7.5L10 13.75L5 7.5H15Z" fill="#DE4527" />
            </svg>
            -->

            <CustomSelect v-model="selections.year" :options="dropdowns.year" :placeholder="yearLabel || 'Select Year'"
                :disabled="dropdowns.year.length < 1" @option-changed="handleOptionChange"/>
        </div>
    </div>
    <div class="make-sub-model">
        <div class="make-model-navigation__select make-sub-model__button">
            <select
                v-bind:class="{ 'selected': selections.submodel != '', 'errored': selections.submodel == '' && showError }"
                name="submodel" id="" v-model="selections.submodel" :disabled="dropdowns.submodel.length < 1" @change="handleSubmodelChange">
                <option value="">{{ submodelLabel || 'Select Submodel' }}</option>
                <option v-for="submodel in dropdowns.submodel" :key="submodel.key" :value="submodel.key" :data-model="submodel.model">{{
                    submodel.value }}</option>
            </select>

            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 7.5L10 13.75L5 7.5H15Z" fill="#DE4527" />
            </svg>
        </div>
    </div>
</template>

<script>
import { range } from 'lodash';
import Ecommerce from '../adapters/Ecommerce';
import Searcher from '../helpers/searcher';
import { slugify } from '../helpers/helpers';
import storage from '../helpers/storage';
import CustomSelect from './CustomSelect.vue';

const Platform = Ecommerce.getInstance(window.sf_options.platform);

export default {
    components: {
        CustomSelect
    },
    props: ['foam', 'videos', 'make', 'model', 'yearLabel', 'submodelLabel', 'facetResults'],
    emits: ['displayYears'],

    data() {
        return {
            started: false,
            showError: false,
            dropdowns: {
                year: [],
                make: [],
                model: [],
                submodel: []
            },
            cached: {
                year: [],
                make: [],
                model: [],
                submodel: []
            },
            selections: {
                year: '',
                make: this.make || '',
                model: this.model || '',
                submodel: ''
            },
            foamVal: this.foam || false
        }
    },

    computed: {
        can_continue() {
            return this.selections.year != '' && this.selections.make != '' && this.selections.model != '' && this.selections.submodel != '';
        }
    },


    watch: {
        'selections.year': function (newval) {
            this.fetchSubmodels(this.make, this.model, newval);
        },
        // 'selections.submodel': function (newval) {
        //     console.log('newval', newval);
        //     // Set Selection model
        //     // this.selections.model = newval;
        //     this.search();
        // },
    },

    async mounted() {
        if (this.make && this.model) {
            // await this.fetchSubmodels(this.make, this.model);
            await this.getYears(this.make, this.model);
        }
    },

    methods: {

        async getYears(make, model) {

            let years, yearFirst, yearLast, foamYears;

            // Split comma-separated model string
            let models = model.split(',')
                .map(m => m.trim())
                .filter(m => m.length);

            // Build OR filter for Algolia
            let modelFilter = models
                .map(m => `vehicle.model:'${m}'`)
                .join(" OR ");

            // Full filter query
            let filters = `active:true AND vehicle.make:'${make}' AND (${modelFilter})`;

            // Get results from facets if available
            if (this.facetResults) {
                // Get Years from facets
                let { facets } = await Searcher.search('*', {
                    // optionalWords: this.isFoam() ? 'foam durofoam' : null,
                    filters: filters,
                    facets: ['vehicle.start_year', 'vehicle.end_year'],
                });

                let startYears = Object.keys(facets['vehicle.start_year']).map(year => parseInt(year));
                let endYears = Object.keys(facets['vehicle.end_year']).map(year => parseInt(year));

                // Merge the two arrays and remove duplicates
                years = Array.from(new Set([...startYears, ...endYears])).sort((a, b) => a - b);

                // Display year range
                yearFirst = parseInt(Object.keys(facets['vehicle.start_year']).sort()[0]);
                yearLast = parseInt(Object.keys(facets['vehicle.end_year']).sort().reverse()[0]);
            } else {
                // Get results from hits
                let hits = await Searcher.searchAll('*', {
                    // optionalWords: this.isFoam() ? 'foam durofoam' : null,
                    filters: filters,
                    facets: ['vehicle.start_year', 'vehicle.end_year']
                });

                // Use a Set for O(1) lookups and uniqueness
                const getYearRangeSet = new Set();
                const getFoamYearRangeSet = new Set();

                // Loop hits and get vehicle start_year and end_year
                hits.forEach(hit => {
                    if (hit.vehicle?.start_year && hit.vehicle?.end_year) {
                        // SKU
                        const sku = hit.part?.sku;
                        const partIsFoam = sku.includes('FOAM');

                        // Make a year range for this entry
                        const start = parseInt(hit.vehicle.start_year, 10);
                        const end = parseInt(hit.vehicle.end_year, 10) + 1; // Include end year

                        for (let year = start; year < end; year++) {
                            getYearRangeSet.add(year);
                            // Check if sku is FOAM
                            if (partIsFoam) {
                                getFoamYearRangeSet.add(year);
                            }
                        }
                    }
                });

                // Convert Set to array and sorted if needed
                years = Array.from(getYearRangeSet).sort((a, b) => a - b);

                // Convert Set to array and sorted if needed
                foamYears = Array.from(getFoamYearRangeSet).sort((a, b) => a - b);

                // Display year range
                yearFirst = years[0];
                yearLast = years[years.length - 1];
            }

            // Push to array
            this.dropdowns['year'] = years.map(year => {
                return {
                    key: year,
                    value: year,
                    hasFoam: !this.isFoam() ? true : foamYears.includes(year)
                };
            });

            // Cache the years
            this.getCachedYears();

            // Emitting the years to the parent component
            let yearEl = `<h3>(${yearFirst} - ${yearLast})</h3>`;
            this.$emit('display-years', yearEl);

        },

        async fetchSubmodels(make, model, year) {

            let models = model.split(',')
                .map(m => m.trim())
                .filter(m => m.length);

            let modelLength = models.length;
         

            let allSubmodels = [];

                    
            for (let i = 0; i < models.length; i++) {
                const result = await this.fetchThisSubmodel(make, models[i], year);
                allSubmodels.push(...result);
            }

            this.dropdowns['submodel'] = allSubmodels;

            // Cached data
            this.getCachedMakes(make, model, year);
            this.cached['submodel'] = allSubmodels;

            return;
        },

        async fetchThisSubmodel(make, model, year) {
            if (!make || !model || !year) {
                return [];
            }
             let { facets } = await Searcher.search('*', {
                optionalWords: null,
                filters: "active:true AND vehicle.make:'" + make + "' AND vehicle.model:'" + model + "' AND vehicle.start_year<=" + year + " AND vehicle.end_year>=" + year,
                facets: ['vehicle.submodel'],
            });

            if( facets && facets[`vehicle.submodel`] ) {
                return Object.keys(facets[`vehicle.submodel`]).sort().map(val => {
                    return { key: val, value: `${make} ${model} ${val}`, model: model }
                });  
            } else {
                return [];
            }
        },

        async search() {

            if (!this.can_continue) {
                this.showError = true;
                if (typeof window?.sf_options?.onYmmsError === 'function') {
                    window.sf_options.onYmmsError();
                }
                return;
            } else {
                this.showError = false;
            }

            if (typeof window?.sf_options?.onYmmsSearch === 'function') {
                window.sf_options.onYmmsSearch();
            }

            // let {hits} = await Searcher.search( this.isFoam() ? 'foam durofoam' : '*', {
            //     optionalWords: this.isFoam() ? 'foam durofoam' : null, 
            //     filters: Searcher.buildFilters(this.selections)
            // });

            storage.storeLastVehicleSelection({
                selections: this.selections,
                dropdowns: this.cached
            });

            let params = { ...this.selections };

            // console.log('params', this.selections);

            if (this.isVideos()) {
                return this.$emit('vehicleSelected', params);
            }

            Platform.goToPartResults(slugify(
                Object.values(params).join('-')
            ), {
                ...params,
                ...{ foam: false }
            });
        },

        isFoam() {

            if (this.foamVal) {
                return true;
            }

            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('foam') == 'true' ? true : false;
        },

        isVideos() {
            if (this.videos) {
                return true;
            }

            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('videos') ? true : false;
        },


        async getCachedYears() {

            let { facets } = await Searcher.search('*', {
                optionalWords: null,
                facets: ['vehicle.start_year', 'vehicle.end_year']
            });

            let years = range(
                parseInt(Object.keys(facets['vehicle.start_year']).sort()[0]),
                parseInt(Object.keys(facets['vehicle.end_year']).sort().reverse()[0]) + 1, // We add the +1 because the range method doesn't include the end value.  
            );

            this.cached['year'] = years.map(year => {
                return { key: year, value: year };
            });

            return;
        },

        async getCachedMakes(make, model, year) {
            if (!year) {
                return;
            }
            let { facets } = await Searcher.search('*', {
                optionalWords: null,
                filters: "active:true AND vehicle.start_year<=" + year + " AND vehicle.end_year>=" + year,
                facets: ['vehicle.make'],
            });

            // Get Models
            this.getCachedModels(make, model, year);

            // Set make
            this.cached['make'] = Object.keys(facets[`vehicle.make`]).sort().map(val => {
                return { key: val, value: val }
            });

            return;
        },

        async getCachedModels(make, model, year) {
            if (!make || !year) {
                return;
            }

            let { facets } = await Searcher.search('*', {
                optionalWords: null,
                filters: "active:true AND vehicle.make:'" + make + "' AND vehicle.start_year<=" + year + " AND vehicle.end_year>=" + year,
                facets: ['vehicle.model'],
            });

            // Set model
            this.cached['model'] = Object.keys(facets[`vehicle.model`]).sort().map(val => {
                return { key: val, value: val }
            });

            return;
        },

        handleOptionChange(option) {
            this.foamVal = option.hasFoam;
        },

        handleSubmodelChange(event) {
            const select = event.target;
            const option = select.options[select.selectedIndex];

            this.selections.submodel = select.value;
            this.selections.model = option.dataset.model;

            this.search();
        }
    }
}

</script>